// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const EDIT_TESTING_FINISHED_POST = "Uprav fin\u00e1lny text testovania";
export const SEO_DESCRIPTION_COUNSELLINGS = "Pora\u010f sa s odborn\u00edkmi o tom, \u010do pr\u00e1ve rie\u0161i\u0161. V poradniach Modr\u00e9ho kon\u00edka n\u00e1jde\u0161 odpovede na ot\u00e1zky z r\u00f4znych oblast\u00ed \u017eivota.";
export const SEO_TITLE_TESTINGS = "Testovania";
